import moment from 'moment-timezone';



function parseSchedule(rawSchedule, timeZone) {
  const result = {
    nextAvailable: null,
    today: []
  };

  if (rawSchedule.length === 0 || !timeZone) {
    return result;
  }

  const scheduleGroups = {
    sunday: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: []
  };

  rawSchedule.forEach((schedule) => {
    const dayName = schedule.day.toLowerCase();
    scheduleGroups[dayName].push(schedule);
  });

  const dayNames = Object.keys(scheduleGroups);
  const now = moment.tz(timeZone);
  const currentDayName = now.format('dddd').toLowerCase();
  const currentDayNameIndex = dayNames.indexOf(currentDayName);
  const dayNamesToWrap = dayNames.splice(0, currentDayNameIndex);
  const dayNamesOrdered = [...dayNames, ...dayNamesToWrap];
  const parsedSchedules = [];

  dayNamesOrdered.forEach((dayName, dayOffset) => {
    scheduleGroups[dayName].forEach((schedule) => {
      if (!schedule || (schedule.startTime === '00:00:00' && schedule.endTime === '00:00:00')) {
        return;
      }

      const isToday = dayName === currentDayName;
      const startSegments = schedule.startTime.split(':');
      const startTime = moment().tz(timeZone).add(dayOffset, 'days');
      startTime.hours(startSegments[0]).minutes(startSegments[1]).seconds(0);
      const isNextAvailable = startTime.diff(now) >= 0;
      const startTimestamp = startTime.utc().format();

      parsedSchedules.push({
        ...schedule,
        hasSpecialHours: !(schedule.startTime === '00:00:00' && schedule.endTime === '23:59:59'),
        isNextAvailable,
        isToday,
        startTimestamp
      });
    });
  });

  result.today = parsedSchedules.filter(schedule => schedule.isToday);

  result.nextAvailable = parsedSchedules.find(schedule => schedule.isNextAvailable) || null;

  return result;
}



export default parseSchedule;
